export default __webpack_public_path__ + "static/ogg-image-default-0f7842f41bf2b1c3369b4161b7f59d99.png";